<template>
  <SbMenu
    :model-value="isMenuOpen"
    @close="closeMenu"
    class="sb-breadcrumbs__dropdown"
  >
    <SbMenuButton
      ref="hiddenBreadcrumbItems"
      label="..."
      hidden-label="Show more items"
      is-clear
      size="small"
      class="sb-breadcrumbs__dropdown-button"
      @click="handleToggleMenu"
    />
    <SbMenuList
      placement="bottom-start"
      class="sb-breadcrumbs__dropdown-list"
      use-portal
      :reference="hiddenBreadcrumbItems"
    >
      <SbMenuItem
        v-for="(item, index) in items"
        :key="index"
        @click="handleItemSelect(item.id)"
      >
        <SbBreadcrumbLink
          :as="as || item.linkType"
          :item-id="item.id"
          class="sb-dropdown-item__content sb-breadcrumbs__dropdown-link"
          :href="item.href"
          :to="item.to"
          :target="item.target"
          :disabled="item.disabled"
          :label="item.label"
          :disable-link-navigation="disableLinkNavigation"
        />
      </SbMenuItem>
    </SbMenuList>
  </SbMenu>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import { SbMenu, SbMenuItem, SbMenuButton, SbMenuList } from '../Menu'
import SbBreadcrumbLink from './BreadcrumbLink.vue'
import type { BreadcrumbLinkType, BreadcrumbItem } from './types'

const props = defineProps<{
  items: BreadcrumbItem[]
  as?: BreadcrumbLinkType
  disableLinkNavigation?: boolean
}>()

const emit = defineEmits<{
  (e: 'select-item', itemId: string | undefined): void
}>()

const hiddenBreadcrumbItems = ref<HTMLButtonElement | undefined>(undefined)

const isMenuOpen = ref<boolean>(false)

function handleItemSelect(itemId: string | number | undefined): void {
  const item = props.items.find((i) => String(i.id) === String(itemId))
  if (!item) return

  if (item.href && !props.disableLinkNavigation) {
    window.open(item.href, item.target || '_self')
    closeMenu()
    return
  }

  emit('select-item', String(itemId))
  closeMenu()
}

function handleToggleMenu(): void {
  isMenuOpen.value = !isMenuOpen.value
}

function closeMenu(): void {
  isMenuOpen.value = false
}
</script>
